// set an info box in form based on dependend select fields

import { form } from "./form";

export function formInfoBox() {
    // Show info on "Privatvermarkter"
    const privateMarketer = document.querySelector<HTMLFormElement>(
        '[data-select-id="level_of_action"]',
    );
    if (privateMarketer) {
        const infobox = document.querySelector<HTMLElement>(
            '[data-info-element="level-of-action-info"]',
        );
        const taxNumberLabel = document.querySelector<HTMLFormElement>(
            '[data-select-id="taxnumber-label"]',
        );

        if (infobox && taxNumberLabel) {
            // on DOMcontentLoaded check if there is "Privatvermarkter" selected
            document.addEventListener("DOMContentLoaded", function () {
                if (privateMarketer.value === "Privatvermarkter") {
                    taxNumberLabel.innerHTML = "Steueridentifikationsnummer";
                    infobox?.classList.add("visible");
                }
            });

            privateMarketer.addEventListener("sl-change", () => {
                if (privateMarketer.value === "Privatvermarkter") {
                    infobox?.classList.add("visible");
                    taxNumberLabel.innerHTML = "Steueridentifikationsnummer";
                } else {
                    infobox?.classList.remove("visible");
                    taxNumberLabel.innerHTML = "Steuernummer";
                }
            });
        }
    }

    // idtype 10 characters validation on "Personalausweis"
    const idType = document.querySelector<HTMLFormElement>(
        '[data-select-id="idtypeid"]',
    );
    if (idType) {
        const idCardNr = document.querySelector<HTMLFormElement>(
            '[data-select-id="id-card-number"]',
        );
        if (idCardNr) {
            const nationalID = document.querySelector<HTMLFormElement>(
                '[data-select-id="nationaliyid"]',
            );
            const infobox = document.querySelector<HTMLElement>(
                '[data-info-element="id-card"]',
            );
            const germanyNationalSelection = "48";
            const germanySelection = "3";

            // on DOMcontentLoaded check if there is country and id type 'Personalausweis'
            document.addEventListener("DOMContentLoaded", function () {
                if (
                    idType.value === germanySelection &&
                    nationalID?.value === germanyNationalSelection
                ) {
                    idCardNr.dataset.validates = "id-card";
                    infobox?.classList.add("visible");
                    idCardNr.setAttribute("maxlength", "10");
                } else {
                    idCardNr.dataset.validates = "at-least-four";
                }
            });
            // on nationalID change to Germany, set id type default to 'Personalausweis'
            nationalID?.addEventListener("sl-change", () => {
                if (nationalID.value === germanyNationalSelection) {
                    idCardNr.dataset.validates = "id-card";
                    infobox?.classList.add("visible");
                    idCardNr.setAttribute("maxlength", "10");
                    idType.value = "3";
                } else {
                    idCardNr.dataset.validates = "at-least-four";
                    infobox?.classList.remove("visible");
                    idCardNr.removeAttribute("maxlength");
                }
                // re add the validation rules:
                form();
            });
            // on id Type change, set visibility of info container / set maxlength / validation accordingly
            idType.addEventListener("sl-change", () => {
                if (
                    idType.value === germanySelection &&
                    nationalID?.value === germanyNationalSelection
                ) {
                    idCardNr.dataset.validates = "id-card";
                    infobox?.classList.add("visible");
                    idCardNr.setAttribute("maxlength", "10");
                } else {
                    idCardNr.dataset.validates = "at-least-four";
                    infobox?.classList.remove("visible");
                    idCardNr.removeAttribute("maxlength");
                }
                // re add the validation rules:
                form();
            });
        }
    }
}
